export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto text-center">
        <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-500 mb-3">About</span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">关于黑料吃瓜爆料</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[700px] mx-auto">
          黑料吃瓜爆料网是国内领先的娱乐资讯聚合平台，致力于为吃瓜群众提供最快、最全、最准的明星八卦和网络爆料内容。
          我们通过智能算法实时监控全网50余个主流社交平台，覆盖微博、抖音、快手、小红书、豆瓣、知乎等核心阵地，
          确保每一条热门黑料、每一个明星八卦都能第一时间触达用户。平台每日更新超过3,000条鲜辣内容，
          涵盖娱乐圈、网红圈、直播圈等多个领域，是真正的吃瓜查询一站式入口。
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          {[
            { num: '50+', label: '监控平台' },
            { num: '3,000+', label: '日更新量' },
            { num: '2,847', label: '今日快讯' },
            { num: '800万+', label: '月活跃用户' },
          ].map((stat, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-4">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.num}</div>
              <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}